import React, { useMemo, Children, useState, useRef, useEffect, useCallback } from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import { callAllHandlers } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Nav } from '../Nav/Nav.es.js';
import { Badge } from '../Badge/Badge.es.js';
import { Fade } from '../Fade/Fade.es.js';
import '../MaestroThemeProvider/MaestroThemeProvider.es.js';
import { ColorMode } from '../MaestroThemeProvider/ColorMode.es.js';
import { useExperiment } from '../MaestroThemeProvider/ExperimentalProvider/ExperimentalProvider.es.js';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/XFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import CaretLeftOutlined from '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import CaretRightOutlined from '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import { Pane as Pane$1, Wrapper, ScrollButton, ScrollContainer, Tablist } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Pane = maestroComponent("Tabs.Pane", Pane$1);
const Tabs = (_a) => {
  var _b = _a, {
    children,
    selectedTab,
    onSelectTab,
    size = "md",
    isLazy = true,
    variant = "tab",
    align = "left",
    allowScrollToTab = true
  } = _b, props = __objRest(_b, [
    "children",
    "selectedTab",
    "onSelectTab",
    "size",
    "isLazy",
    "variant",
    "align",
    "allowScrollToTab"
  ]);
  var _a2;
  const getPanes = (children2) => Children.toArray(children2);
  const panes = useMemo(() => getPanes(children) || [], [children]);
  const tabsContent = useMemo(() => [], []);
  const defaultSelectedTab = selectedTab ? selectedTab : (_a2 = panes[0]) == null ? void 0 : _a2.props.name;
  const [activeTab, setActiveTab] = useState();
  const changeTabPane = (paneName) => {
    if (activeTab !== paneName) {
      typeof onSelectTab === "function" ? onSelectTab(paneName) : setActiveTab(paneName);
    }
  };
  const handleKeyPress = (e, currentIndex) => {
    if (!(e.key === "ArrowLeft" || e.key === "ArrowRight")) {
      return;
    }
    const firstTabIndex = 0;
    const lastTabIndex = panes.length - 1;
    let nextPosition = e.key === "ArrowLeft" ? currentIndex - 1 : currentIndex + 1;
    if (nextPosition > lastTabIndex) {
      nextPosition = firstTabIndex;
    }
    if (nextPosition < firstTabIndex) {
      nextPosition = lastTabIndex;
    }
    const nextPane = panes[nextPosition];
    changeTabPane(nextPane.props.name);
    tabsContent[nextPosition].focus();
  };
  const tabsScrollerRef = useRef(null);
  const handleScroll = (direction) => {
    if (!tabsScrollerRef.current)
      return;
    const isForward = direction === "forward";
    const element = tabsScrollerRef.current;
    element.scrollBy({
      left: (isForward ? element.offsetWidth : -element.offsetWidth) * 0.5,
      behavior: "smooth"
    });
  };
  const [isTabsArrowEnabled] = useExperiment("tabsArrow");
  const [isScrollable, setIsScrollable] = useState(false);
  const [showScrollForward, setShowScrollForward] = useState(false);
  const [showScrollBackward, setShowScrollBackward] = useState(false);
  useEnhancedEffect(() => {
    if (!tabsScrollerRef.current)
      return;
    const element = tabsScrollerRef.current;
    const update = () => {
      if (element.scrollWidth > element.clientWidth) {
        setIsScrollable(true);
      } else {
        setIsScrollable(false);
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
    };
  }, []);
  const [leftMaskOpacity, setLeftMaskOpacity] = useState(1);
  const [rightMaskOpacity, setRightMaskOpacity] = useState(1);
  const controlsStyles = {
    "--left-mask-opacity": leftMaskOpacity,
    "--right-mask-opacity": rightMaskOpacity
  };
  useEffect(() => {
    setLeftMaskOpacity(showScrollBackward ? 0 : 1);
    setRightMaskOpacity(showScrollForward ? 0 : 1);
  }, [showScrollBackward, showScrollForward]);
  const onScroll = useCallback((event) => {
    var _a3;
    if (!event || !isTabsArrowEnabled)
      return;
    ((_a3 = event.target) == null ? void 0 : _a3.scrollLeft) <= 0 ? setShowScrollBackward(false) : setShowScrollBackward(true);
    event.target.scrollLeft >= event.target.scrollWidth - event.target.offsetWidth ? setShowScrollForward(false) : setShowScrollForward(true);
  }, [isTabsArrowEnabled]);
  useEffect(() => {
    if (!tabsScrollerRef.current)
      return;
    if (!isScrollable || !isTabsArrowEnabled) {
      setShowScrollBackward(false);
      setShowScrollForward(false);
    } else {
      setShowScrollForward(true);
    }
    const element = tabsScrollerRef.current;
    element.addEventListener("scroll", onScroll);
    return () => {
      element.removeEventListener("scroll", onScroll);
    };
  }, [isScrollable, isTabsArrowEnabled, onScroll]);
  const scrollToTab = useCallback((selectedTab2) => {
    const activeTabIndex = panes.findIndex((pane) => pane.props.name === selectedTab2);
    const activeTabRef = tabsContent[activeTabIndex];
    if (allowScrollToTab && activeTabRef) {
      scrollIntoViewIfNeeded(activeTabRef, {
        scrollMode: "if-needed",
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
        boundary: tabsScrollerRef.current
      });
    }
  }, [allowScrollToTab, panes, tabsContent]);
  useEffect(() => {
    if (!activeTab) {
      setActiveTab(defaultSelectedTab);
      scrollToTab(defaultSelectedTab);
      return;
    }
    if (!selectedTab) {
      return;
    }
    if (activeTab !== selectedTab) {
      setActiveTab(selectedTab);
      scrollToTab(selectedTab);
    }
  }, [defaultSelectedTab, scrollToTab, activeTab, selectedTab]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    width: "100%"
  }, props), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Fade, {
    in: showScrollBackward,
    timeout: 150,
    mountOnEnter: true
  }, /* @__PURE__ */ React.createElement(ScrollButton, {
    direction: "backward",
    disabled: !showScrollBackward,
    onClick: () => handleScroll("backward")
  }, /* @__PURE__ */ React.createElement(CaretLeftOutlined, null))), /* @__PURE__ */ React.createElement(ScrollContainer, {
    style: controlsStyles,
    ref: tabsScrollerRef
  }, /* @__PURE__ */ React.createElement(Tablist, {
    variant,
    role: "tablist",
    size,
    align
  }, panes.map((pane, paneIndex) => {
    var _a3, _b2, _c;
    const isActivePane = activeTab === pane.props.name;
    const hasBadge = !!((_a3 = pane == null ? void 0 : pane.props) == null ? void 0 : _a3.badgeContent);
    const handleTabClick = () => changeTabPane(pane.props.name);
    return /* @__PURE__ */ React.createElement(Nav.Item, {
      key: paneIndex
    }, /* @__PURE__ */ React.createElement(Nav.Link, {
      role: "tab",
      ref: (ref) => tabsContent[paneIndex] = ref,
      tabIndex: isActivePane ? 0 : -1,
      "aria-current": isActivePane ? true : void 0,
      icon: (_b2 = pane == null ? void 0 : pane.props) == null ? void 0 : _b2.icon,
      hasBadge,
      onClick: callAllHandlers(handleTabClick),
      onKeyDown: (event) => handleKeyPress(event, paneIndex)
    }, pane.props.label, hasBadge && /* @__PURE__ */ React.createElement(ConditionalWrapper, {
      condition: isActivePane && variant === "pill",
      wrapper: (children2) => /* @__PURE__ */ React.createElement(ColorMode, {
        mode: "invert"
      }, children2)
    }, /* @__PURE__ */ React.createElement(Badge, {
      variant: ((_c = pane == null ? void 0 : pane.props) == null ? void 0 : _c.badgeVariant) || "default",
      content: pane.props.badgeContent,
      isRounded: true,
      kind: "subtle",
      ml: "xs"
    }))));
  }))), /* @__PURE__ */ React.createElement(Fade, {
    in: showScrollForward,
    timeout: 150,
    mountOnEnter: true
  }, /* @__PURE__ */ React.createElement(ScrollButton, {
    direction: "forward",
    disabled: !showScrollForward,
    onClick: () => handleScroll("forward")
  }, /* @__PURE__ */ React.createElement(CaretRightOutlined, null)))), isLazy && panes.find((pane) => activeTab === pane.props.name), !isLazy && panes.map((pane, index) => /* @__PURE__ */ React.createElement(Box, {
    key: index,
    hidden: activeTab === pane.props.name ? false : true
  }, pane)));
};
Tabs.displayName = "Tabs";
var Tabs$1 = Object.assign(Tabs, { Pane });

export { Tabs$1 as default };
//# sourceMappingURL=Tabs.es.js.map
